import { orchid_decrypt } from "utils/OrchidEncryption";

const decryptWhenHasData = async (decodeKey: CryptoKey, data?: string) => {
  if (!data) {
    return;
  }

  try {
    const decoded = await orchid_decrypt(data, decodeKey);
    if (!decoded) {
      return;
    }

    try {
      return JSON.parse(decoded);
    } catch (error) {
      return decoded;
    }
  } catch (error) {
    return;
  }
};

export default decryptWhenHasData;
